import { BaseError } from '@/util/base-error'

export class MailMagazineSubscribeError extends BaseError {
  constructor(
    message: string,
    readonly label: string
  ) {
    super(message)
  }
}
